<div class="relative">
  <div class="p-4">
    <div [innerHTML]="'HOTEL_BOOKING_INSTRUCTIONS' | translate"></div>
  </div>
</div>
